import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import { STATUS_OPTIONS, STATUS_BADGE } from '../../Constant/leadConstent';
import { getRemarkList } from "../../redux/services/RemarkServices/Remark.Services";
import { getUserRole } from "../../Utils/role";
import { updateLeadStatus, getLeadDetails } from "../../redux/services/leadServices/Lead.Services"

function ReamrkList() {
    const role = getUserRole();
    const dispatch = useDispatch();
    const { id } = useParams()
    const navigate = useNavigate();
    const [leadData, setLeadData] = useState([]);
    const [lead, setLead] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (id) {
            fetchRemarks(id);
            fetchLeadDetails();
        }
    }, [id]);

    const fetchRemarks = async (leadId) => {
        try {
            setLoading(true);
            const payload = {
                id: leadId,
                lead_id: leadId,
            };
            const response = await getRemarkList(payload);
            if (response?.success) {
                setLeadData(response.data || []);
            } else {
                setLeadData([]);
            }
        } catch (error) {
            console.log("Error:", error);
            setLeadData([]);
        } finally {
            setLoading(false);
        }
    };
    const fetchLeadDetails = async () => {
        try {
            const res = await getLeadDetails(id);

            if (res?.success) {
                setLead(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const formatDate = (date) => {
        return new Date(date)
            .toLocaleDateString("en-GB")
            .replace(/\//g, "-");
    };

    const formatTime = (time) => {
        if (!time) return "";

        const [hours, minutes] = time.split(":");

        const date = new Date();
        date.setHours(hours, minutes);

        return date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };
    if (loading) {
        return <h3>Loading...</h3>;
    }



    return (
        <div>

            {/* HEADER */}
            <div className="pageheaderall position-relative d-md-flex align-items-center justify-content-between page-header-breadcrumb">

                <div className="page-header">
                    <div>
                        <h3 className="page-title">All Remark List</h3>

                        <nav className="page-breadcrumb">
                            <Link to="/">Home</Link>
                            <span className="mx-2">/</span>
                            <span>All Remark List</span>
                        </nav>
                    </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                    <button
                        className="add-btn"
                        onClick={() =>
                            dispatch(
                                openModal({
                                    type: "add-remark",
                                    title: "Add Remark",
                                    data: {
                                        id: id,
                                        statusOptions: STATUS_OPTIONS,
                                        currentStatus: lead?.status,
                                        refreshRemarks: () => fetchRemarks(id),
                                        onSubmit: async (payload) => {
                                            const res = await updateLeadStatus(payload);
                                            return res;
                                        },
                                    },
                                })
                            )
                        }
                    >
                        Add Remark
                    </button>

                    <button className="lead-btn btn-filter" onClick={() => navigate(-1)}>
                        Back
                    </button>
                </div>

            </div>

            <div className="main_page">
                <div className="st-wrapper-card text-center">
                    <div className="st-table-responsive">
                        <table className="table st-custom-table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Sr.No</th>
                                    <th>Remark</th>
                                    {/* <th>Next FollowUp Date</th> */}
                                    {/* <th>Remark By</th>
                            <th>Remark To</th> */}
                                    {role === "admin" && (
                                        <>
                                            {/* <th>Assigned</th> */}
                                            <th>Remark Info</th>
                                        </>
                                    )}
                                    <th>Status</th>
                                    <th>Date</th>
                                    {/* <th>Action</th> */}

                                </tr>

                            </thead>

                            <tbody>

                                {
                                    leadData.map((item, index) => (
                                        <tr key={item.id}>

                                              {/* <td> {(page - 1) * limit + index + 1}</td> */}
                                              <td> { index + 1}</td>
                                            <td>{item.remarks || "-"}</td>
                                            {/* <td>
                                            <div className="d-flex align-items-center gap-2">
                                                <span className="whitedesign text-primary fw-semibold">
                                                    By: {item?.lead_details?.assign_by?.name || "-"}
                                                </span>

                                                <span>|</span>

                                                <span className="whitedesign text-success fw-semibold">
                                                    To: {item?.lead_details?.assign_to?.name || "-"}
                                                </span>
                                            </div>
                                        </td> */}
                                            {role === "admin" && (
                                                <>
                                                    {/* <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span className="whitedesign text-primary fw-semibold">
                                                        By: {item?.lead_details?.assign_by?.name || "-"}
                                                    </span>

                                                    <span>|</span>

                                                    <span className="whitedesign text-success fw-semibold">
                                                        To: {item?.lead_details?.assign_to?.name || "-"}
                                                    </span>
                                                </div>
                                            </td> */}
                                                    <td>
                                                        <div className="">
                                                            <span className="  fw-semibold">
                                                                By: {item?.user_details?.name || "-"}
                                                            </span>
                                                        </div>
                                                    </td>
                                                </>
                                            )}
                                            {/* <td>{item.new_status || "-"}</td> */}
                                            <td>
                                                <span
                                                    className={`status-badge ${STATUS_BADGE[item.new_status]
                                                        }`}
                                                >
                                                    {item.new_status || "-"}
                                                </span>
                                            </td>
                                            <td>
                                                {item?.date
                                                    ? `${formatDate(item.date)} | ${formatTime(item.time)}`
                                                    : "-"}
                                            </td>



                                        </tr>

                                    ))
                                }

                            </tbody>

                        </table>

                    </div>

                </div>
            </div>

        </div>
    );
}

export default ReamrkList;